export const DepthPercentageSlider = {
  min: 0,
  max: 100,
  step: 0.01
}

export const TablePercentageSlider = {
  min: 0,
  max: 100,
  step: 0.01
}

export const LWRatioSlider = {
  minDistance: 0.01,
  min: 0.01,
  max: 5,
  step: 0.01
}

export const SizeSlider = {
  minDistance: 0.1,
  min: 0,
  max: 20,
  step: 0.01
}

export const WeightSlider = {
  minDistance: 0.1,
  min: 0.01,
  max: 10,
  step: 0.01
}

export const PriceSlider = {
  minDistance: 1,
  min: 0,
  max: 250000
}



// WEBPACK FOOTER //
// ./src/utils/slider-configs.js